/** Shared style tokens for the Installation Wizard.
 *  Only values that have no Bootstrap utility equivalent live here. */

export const SEPARATOR_COLOR = "rgba(255,255,255,0.08)";
export const MUTED_TEXT_COLOR = "rgba(255,255,255,0.55)";
export const SEPARATOR_BORDER = `1px solid ${SEPARATOR_COLOR}`;
export const PRIMARY_HALO = "0 0 0 3px rgba(94,114,228,0.18)";
export const FONT_MONO = "var(--font-mono, SFMono-Regular, Menlo, monospace)";

export const FIELD_MONO_STYLE = { fontFamily: FONT_MONO };
export const FIELD_OPTION_STYLE = { backgroundColor: "var(--card-bg, #1a1e34)", color: "inherit" };
export const SECTION_DIVIDER_STYLE = { borderTop: SEPARATOR_BORDER, margin: "1rem 0" };
